/*
    Documentation: https://angular.io/guide/ngmodule#the-core-module

    This module is for PROVIDERS only. Providers include: services, pipes, guards, and so on.
    Do not load components or modules in this module!
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { CustomHttpInterceptor } from '@core/interceptors';

// CoreModule Directives
import * as Directives from '@core/directives';

// CoreModule services
import * as Services from '@core/services';

import { CheckoutService } from '@features/ordering/services/checkout.service';

import * as Guards from '@core/guards';
// import { PAYMENT_OPTIONS, PaymentRequestModule } from '@ng-web-apis/payment-request';

@NgModule({
    imports: [
      CommonModule,
      // PaymentRequestModule
    ],
    declarations: [
      Directives.AppOffClickDirective,
      Directives.LazyLoadDirective,
      Directives.ScrollToDirective,
      Directives.WrapFocusDirective,
    ],
    exports: [
      CommonModule,
      Directives.AppOffClickDirective,
      Directives.LazyLoadDirective,
      Directives.ScrollToDirective,
      Directives.WrapFocusDirective
    ],
    providers: [
      // providers
      // {
      //   provide: [PAYMENT_OPTIONS],
      //   useValue: {
      //     shippingType: 'express',
      //     requestPayerName: false,
      //     requestShipping: false,
      //     requestPayerEmail: false,
      //   }
      // },
      Services.ApiService,
      Services.TrackModalService,
      Services.AuthTrackingService,
      Services.LoggedDataService,
      Services.ProxyService,
      Services.ModalService,
      Services.ValidationService,
      Services.LocDataService,
      Services.LocTrackingService,
      Services.CustomizeHttpheaderService,
      Services.ConfirmModalService,
      Services.ResolutionService,
      Services.SignOutService,
      Services.OverlayService,
      Services.SelectorService,
      Services.MenuUtilityService,
      Services.RouterExtService,
      Services.NavigationService,
      Services.AccountMessagingService,
      Services.RewardItemService,
      Services.OfferService,
      Services.AlertService,
      Services.GetOrderService,
      Services.AuthenticationService,
      Services.DetectBrowser,
      Services.PaymentRequestService,
      Services.GenericPaymentRequestService,
      Services.SubmitFeedbackService,
      Services.SubNavService,
      Services.CustomizationSubgroupService,
      Services.GtmService,
      Services.VisitService,
      Services.LocationCoreService,
      Services.SeoService,
      Services.UtilitiesService,
      Services.ChatService,
      Services.JitMigrationService,
      Services.MigrationNudgeStateService,
      Services.SocialMigrationService,
      Services.CiamFlagsService,
      Guards.AuthenticationGuard,
      Guards.CiamV6Guard,
      Guards.Auth0MagicLinkRedirectGuard,
      Guards.CanDeactivateGuard,
      Guards.ChangePasswordGuard,
      Guards.StartOrderGuard,
      Guards.ForceHTTPSGuard,
      Guards.CheckLocationGuard,
      Guards.EmailVerificationGuard,
      Guards.SubNavGuard,
      Guards.ContactUsCheckGuard,
      Guards.VisitsGuard,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: CustomHttpInterceptor,
        multi: true
      },
      Title,
      CheckoutService
    ]
})
export class CoreModule { }
